import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { getPossibleUndefinedJSON } from "../infrastructure/api/digipost-fetch";
import { EnkelVirksomhetInfo } from "../infrastructure/api/api";
import { useCallback } from "react";

export function useHentVirksomhetInfo() {
  const entrypoint = useEntrypointContext();

  const hentVirksomhetInfo = useCallback(
    async (orgNr: string) => {
      const url =
        findURIAndReplaceOrigin("selskap-info", entrypoint._links) + orgNr;
      return await getPossibleUndefinedJSON<EnkelVirksomhetInfo>(url);
    },
    [entrypoint._links],
  );

  return { hentVirksomhetInfo };
}
